import { IconProps } from './types';

export function MagnifyingGlass({ size, ...props }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M9.58073 18.1248C4.8724 18.1248 1.03906 14.2915 1.03906 9.58317C1.03906 4.87484 4.8724 1.0415 9.58073 1.0415C14.2891 1.0415 18.1224 4.87484 18.1224 9.58317C18.1224 14.2915 14.2891 18.1248 9.58073 18.1248ZM9.58073 2.2915C5.55573 2.2915 2.28906 5.5665 2.28906 9.58317C2.28906 13.5998 5.55573 16.8748 9.58073 16.8748C13.6057 16.8748 16.8724 13.5998 16.8724 9.58317C16.8724 5.5665 13.6057 2.2915 9.58073 2.2915Z"
        fill="currentColor"
      />
      <path
        d="M18.3365 18.958C18.1781 18.958 18.0198 18.8997 17.8948 18.7747L16.2281 17.108C15.9865 16.8664 15.9865 16.4664 16.2281 16.2247C16.4698 15.983 16.8698 15.983 17.1115 16.2247L18.7781 17.8914C19.0198 18.133 19.0198 18.533 18.7781 18.7747C18.6531 18.8997 18.4948 18.958 18.3365 18.958Z"
        fill="currentColor"
      />
    </svg>
  );
}
